import {
  GET_BRANCH,
  GET_BRANCH_UPLOAD,
  GET_CATEGORY,
  GET_DATA_EMISSION_SCOPE_3,
  GET_SCOPE,
  SET,
  SET_ABOUT_ME,
  SET_CLASSIFICATION_ELECTRIC_ID,
  SET_HIDDEN_COLUMNS,
  SET_LOADER,
  SET_PREMIUM,
  SET_SEARCH_PARAMS_REGISTRATION_DATA,
} from 'redux/action/type'
import { sortArrayByCategoryName } from 'utils/helpers/common'

interface state {
  sidebarShow: boolean
  sidebarUnfoldable: boolean
  asideShow: boolean
  theme: string
}

interface IDataApiCommon {
  dataScope: any
  dataBranchUpload: any
  dataCategory: ICategory[]
  dataEmissionScope3: any
  classificationElectricId?: string
  hiddenRegistrationTableColumns: string[]
  searchParamsRegistrationData?: string
  me: IUser | null
}

const initialState: state = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  asideShow: false,
  theme: 'default',
}

const initialStateScope: IDataApiCommon = {
  dataScope: [],
  dataBranchUpload: null,
  dataCategory: [],
  dataEmissionScope3: [],
  classificationElectricId: '',
  hiddenRegistrationTableColumns: [],
  searchParamsRegistrationData: '',
  me: null,
}

const initialStateScope3: any = {
  dataEmissionScope3: [],
}

const initialStatePremium: any = {
  isPremium: false,
}

type args = { type?: string; [key: string]: any }

const changeStateReducer = (state = initialState, { type, ...rest }: args) => {
  switch (type) {
    case SET:
      return { ...state, ...rest }
    default:
      return state
  }
}

const loaderReducer = (state: boolean = false, action: ILoaderReduxAction) => {
  switch (action.type) {
    case SET_LOADER:
      return action.data
    default:
      return state
  }
}

const commonReducer = (state = initialStateScope, action: any) => {
  switch (action.type) {
    case GET_SCOPE:
      return {
        ...state,
        dataScope: action.data,
      }
    case GET_BRANCH:
      return {
        ...state,
        dataBranch: action.data,
      }
    case GET_BRANCH_UPLOAD:
      return {
        ...state,
        dataBranchUpload: action.data,
      }
    case GET_CATEGORY:
      return {
        ...state,
        dataCategory: sortArrayByCategoryName(action.data),
      }
    case GET_DATA_EMISSION_SCOPE_3:
      return {
        ...state,
        dataEmissionScope3: action.data,
      }
    case SET_CLASSIFICATION_ELECTRIC_ID:
      return {
        ...state,
        classificationElectricId: action.data,
      }
    case SET_HIDDEN_COLUMNS:
      return {
        ...state,
        hiddenRegistrationTableColumns: action.data,
      }
    case SET_SEARCH_PARAMS_REGISTRATION_DATA:
      return {
        ...state,
        searchParamsRegistrationData: action.data,
      }
    case SET_ABOUT_ME:
      return {
        ...state,
        me: action.data,
      }
    default:
      return state
  }
}

const dataScope3Reducer = (state = initialStateScope3, action: any) => {
  switch (action.type) {
    case GET_DATA_EMISSION_SCOPE_3:
      return {
        ...state,
        dataEmissionScope3: action.data,
      }
    default:
      return state
  }
}

const premiumReducer = (state = initialStatePremium, action: any) => {
  switch (action.type) {
    case SET_PREMIUM:
      return {
        ...state,
        isPremium: action.data,
      }
    default:
      return state
  }
}

export {
  changeStateReducer,
  loaderReducer,
  commonReducer,
  dataScope3Reducer,
  premiumReducer,
}
